// axios.js 放入如下
import axios from 'axios';
import utils from "./utils"
//import Cookies from 'js-cookie';

// axios.defaults.timeout = 9999999;
// axios.defaults.baseURL ='https://www.woaiyoufood.com';//生产地址
// axios.defaults.baseURL ='https://www.mvector.cn';//测试地址
// axios.defaults.baseURL ='https://pill.bluepillredpill.cn';//测试地址
// var api = '/api'
// window.axiosArr = []
//http request 拦截器
axios.interceptors.request.use(
  config => {
    // config.cancelToken = new axios.CancelToken(cancel=>{
    //   window.axiosArr.push({cancel})
    // })
    if(!navigator.onLine){
      utils.ToastSuccess("网络不可用，请检查你的网络设置")
    }else {
      if(localStorage.getItem('token')!='undefined'){
        var token = localStorage.getItem('token')
      } else {
        var token = 'f08b6b63-613d-4fec-850d-bcad577b6f3e';
      } //注意使用的时候需要引入cookie方法，推荐js-cookie

      if(config.method=='post'){ // 如果是post请求 请求体自动加上token
          config.data = config.data;
          if(token){
            //config.data.token = token
          }
          // else {
          //   console.log('token失效')
          // }
          config.headers = {
            'Content-Type':'application/json',
            "token":token,
          }
      } else if(config.method=='get'){ // 如果是get请求 url中拼接上
          //config.params.token = token
          config.headers = {
            'Content-Type':'application/json',
            "token":token,
          }
      }
      return config;
    }
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
    // token 可以判断已过期，重定向到登录页面
  response => {
    if(response.data.errCode ==2){
      router.push({
        path:"/login",
        querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      })
    }
    return response;
  },
  error => {
    if(axios.isCancel(error)){
      return new Promise(()=>{})
    }
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios({
        url: "/api"+url,
        method: 'GET',
        params: params,
        })
        .then(res => {
            if(res.data.code == 1001){
                this.$Message.warning('登录超时,' + res.data.message);
                this.$router.push({path:'/login'})
                return
            }
            resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          if (err&&err.response&&err.response.status == 500) {
            this.utils.ToastSuccess("网络不可用，请检查你的网络设置")
           }
            reject(err)
        })
  })
}



/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
        axios({
        url: "/api"+url,
        method: 'POST',
        data: data,
        })
        .then(res => {
            if(res.data.code == 1001){
                //this.$Message.warning('用户超时' + res.data.message);
                this.$router.push({path:'/login'})
                return
            }
            resolve(res);
        })
        .catch(err => {
          if (err&&err.response&&err.response.status === 500) {
            this.utils.ToastSuccess("网络不可用，请检查你的网络设置")
           }
            reject(err)
        })
   })
 }

 /**
  * from 表单
  */
 export function get_from(URL, PARAMS) {
  var p = new Promise((resolve, reject) =>{        //做一些异步操作
    var temp = document.createElement("form");
    temp.action = URL;
    temp.method = "get";
    temp.style.display = "none";
    for (var x in PARAMS) {
      var opt = document.createElement("textarea");
      opt.name = x;
      opt.value = PARAMS[x];
      temp.appendChild(opt);
    }
    document.body.appendChild(temp);
    temp.submit();
    this.$Loading.finish();
    resolve(temp)
  });
  return p;
}

/**
 * 上传 excel
 */

export function up_excel(URL, PARAMS) {
  return new Promise((resolve,reject) => {
    let token = this.$Cookies.get('token')
    let config = {
        headers: {
        'Content-Type': 'multipart/form-data'
        }
    }
    PARAMS.append('token', token)

    axios.post(URL, PARAMS, config)
      .then( res => {
        resolve(res.data)
      })
      .catch(err=>{
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/components/utils/axios.js